export const API_URL = process.env.REACT_APP_API_URL;
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;